@if (value) {
  <mat-icon class="truthy">check_circle</mat-icon>
} @else {
  <mat-icon class="falsy">cancel</mat-icon>
}
<ng-content></ng-content>
